import { isTimeoutError } from '@/services/dataStore/isTransportError'

const RETRY_DELAYS_MS = [1000, 3000]

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const retryTimeouts = async <T>(
  fetchOnce: () => Promise<T>
): Promise<T> => {
  for (const delay of RETRY_DELAYS_MS) {
    try {
      return await fetchOnce()
    } catch (e) {
      if (!isTimeoutError(e)) throw e
      await wait(delay)
    }
  }
  return await fetchOnce()
}
